import {Component, OnDestroy, Signal} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {stages} from '../../location-of-devices-unrelated-to-road.routes';
import {StagesComponent} from '../../../../../../common/stages/stages.component';
import {SpinnerComponent} from '../../../../../../common/spinner/spinner.component';
import {ApplicationAppEntityApplicationRead, RoadOccupationAppEntityApplicationRead} from '../../../../../../openapi';
import {
  selectApplication,
  selectApplicationState,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import {filter, map, Subscription} from 'rxjs';
import {
  LocationOfDevicesUnrelatedToRoadOccupationForm,
  occupationsToFormValue
} from './forms/location-of-devices-unrelated-to-road-occupation.form';
import {
  loadPurposeFeeCollection,
  updateLocationOfDevicesUnrelatedToRoadOccupations
} from '../../../../../../store/actions/application.actions';
import {
  LocationOfDevicesUnrelatedToRoadOccupationFormComponent
} from './components/location-of-devices-unrelated-to-road-occupation-form/location-of-devices-unrelated-to-road-occupation-form.component';
import {ReactiveFormsModule} from '@angular/forms';
import {ServiceListItem} from '../../../../../../services/service.common.model';
import {selectServiceByUrl} from '../../../../../../store/selectors/app.selectors';

@Component({
  selector: 'app-location-of-devices-unrelated-to-road-occupation-data-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    LocationOfDevicesUnrelatedToRoadOccupationFormComponent,
    ReactiveFormsModule
  ],
  providers: [LocationOfDevicesUnrelatedToRoadOccupationForm],
  templateUrl: './location-of-devices-unrelated-to-road-occupation-data-section.component.html'
})
export class LocationOfDevicesUnrelatedToRoadOccupationDataSectionComponent implements OnDestroy {

  public applicationId: string | undefined = this.route.snapshot.params['appId'];

  public stages = stages;

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public serviceType: Signal<ServiceListItem | null> = this.store$.selectSignal(selectServiceByUrl(this.route?.parent?.snapshot?.data['contentUrl']));

  private fetchApplicationData: Subscription = this.store$.select(selectApplicationState)
    .pipe(filter(v => !v.loading))
    .subscribe((state) => {
      const occupations: Array<RoadOccupationAppEntityApplicationRead> = state.application?.roadOccupations || [];
      const value = occupationsToFormValue(occupations).at(0) || null;
      this.form.patchFormValues({
        value,
        purposeFeeCollection: state.purposeFeeCollection
      });
    });

  private fetchRoadOccupationPurpose: Subscription = this.store$.select(selectApplication)
    .pipe(
      map(v => v?.roadOccupationPurpose?.purposeId || v?.service?.roadOccupationPurposes?.at(0)?.purposeId),
      filter(v => !!v)
    ).subscribe((purposeId) => {
      if (purposeId) {
        this.store$.dispatch(loadPurposeFeeCollection({purposeId}));
      }
    });

  constructor(
    public form: LocationOfDevicesUnrelatedToRoadOccupationForm,
    private router: Router,
    private route: ActivatedRoute,
    private store$: Store
  ) {
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], {relativeTo: this.route});
  }

  public submitAndGoNext(): void {
    if (this.form.valid) {
      this.store$.dispatch(updateLocationOfDevicesUnrelatedToRoadOccupations({
        application: this.application(),
        occupations: [this.form.values],
        successFnc: (applicationId) => {
          this.router.navigate(
            ['../oplaty'],
            {
              relativeTo: this.route
            }
          );
        },
        failureFnc: () => {
        }
      }));
    } else {
      this.form.markAllAsTouched();
    }
  }

  public ngOnDestroy(): void {
    this.fetchApplicationData.unsubscribe();
    this.fetchRoadOccupationPurpose.unsubscribe();
  }

}
